module.exports = __webpack_public_path__ + "static/media/question.38e69cfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/question.svg
// module id = 2437
// module chunks = 0